import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { PBRMaterial } from "@babylonjs/core/Materials/PBR/pbrMaterial";
import { CubeTexture } from "@babylonjs/core/Materials/Textures/cubeTexture";
import { Scene } from "@babylonjs/core/scene";
import { Texture } from "@babylonjs/core/Materials/Textures/texture";

export class SkyBox {
  public hdrSkybox!: Mesh;
  public hdrSkyboxMaterial!: PBRMaterial;
  public hdrTexture!: CubeTexture;

  constructor(private uri: string, private scene: Scene, buildSkybox: boolean = true) {
    this.update(uri, buildSkybox);
  }

  update(uri: string, buildSkybox: boolean = true) {
    this.uri = uri;
    const hdrTexture = CubeTexture.CreateFromPrefilteredData(uri, this.scene);
    hdrTexture.gammaSpace = false;
    this.scene.environmentTexture = hdrTexture;

    if ( buildSkybox ) {
      this.hdrSkybox = Mesh.CreateBox("hdrSkyBox", 1000.0, this.scene);
      this.hdrSkyboxMaterial = new PBRMaterial("skyBox", this.scene);
      this.hdrSkyboxMaterial.backFaceCulling = false;
      this.hdrSkyboxMaterial.reflectionTexture = hdrTexture.clone();
      this.hdrSkyboxMaterial.reflectionTexture.coordinatesMode = Texture.SKYBOX_MODE;
      this.hdrSkyboxMaterial.microSurface = 1.0;
      this.hdrSkyboxMaterial.disableLighting = true;
      this.hdrSkybox.material = this.hdrSkyboxMaterial;
      this.hdrSkybox.infiniteDistance = true;
    }
  }
}